import loadable from '@loadable/component'
import Loading from 'components/Loading/Loading'
import { timeout } from 'promise-timeout'
import React from 'react'
import { TIMEOUT_LOADER } from 'utils/globals'

const TypistListECPF = loadable(
  () => timeout(import(
    /* webpackChunkName: "TypistECPF" */
    'ecpf/app/TypistECPF/views/TypistListECPF/TypistListECPF'
  ), TIMEOUT_LOADER),
  {
    fallback: <Loading/>
  }
)

export { TypistListECPF }
